// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contenedor {
  padding: 8px;
}
.contenedor .header,
.contenedor .side,
.contenedor .main,
.contenedor .historial {
  margin: 8px;
}

div.status {
  padding: 7px 12px;
  border-radius: 10px;
  color: white;
  font-weight: bold;
}
div.status.ganado {
  background-color: rgb(54, 175, 54);
}
div.status.perdido {
  background-color: red;
}

div.fase {
  float: left;
  cursor: pointer;
  width: 20%;
}
div.fase div.contenido {
  color: #fff;
  max-width: 300px;
  display: block;
  background: #539cad;
  text-decoration: none;
  position: relative;
  height: 40px;
  line-height: 40px;
  padding: 0 10px 0 5px;
  text-align: center;
  margin-right: 22px;
}
div.fase div.contenido.fase-completa {
  background: #539cad;
}
div.fase:first-child div.contenido {
  padding-left: 15px;
  border-radius: 4px 0 0 4px;
}
div.fase:first-child div.contenido:before {
  border: none;
}
div.fase div.contenido:before, div.fase div.contenido:after {
  content: "";
  position: absolute;
  top: 0;
  border: 0 solid #539cad;
  border-width: 20px 10px;
  width: 0;
  height: 0;
}
div.fase div.contenido:before {
  left: -20px;
  border-left-color: transparent;
}
div.fase div.contenido:after {
  left: 100%;
  border-color: transparent;
  border-left-color: #539cad;
}
div.fase div.contenido.fase-completada {
  background-color: #023b48;
}
div.fase div.contenido.fase-completada:before {
  border-color: #023b48;
  border-left-color: transparent;
}
div.fase div.contenido.fase-completada:after {
  border-left-color: #023b48;
}
div.fase div.contenido:hover {
  background-color: #0a738c;
}
div.fase div.contenido:hover:before {
  border-color: #0a738c;
  border-left-color: transparent;
}
div.fase div.contenido:hover:after {
  border-left-color: #0a738c;
}`, "",{"version":3,"sources":["webpack://./src/app/modulos/crm/components/trato/trato.component.scss","webpack://./src/assets/css/colores.scss"],"names":[],"mappings":"AAEA;EACC,YAAA;AADD;AAEC;;;;EAIC,WAAA;AAAF;;AAaA;EACC,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AAVD;AAYC;EACC,kCAAA;AAVF;AAYC;EACC,qBAAA;AAVF;;AAcA;EACC,WAAA;EACA,eAAA;EACA,UAAA;AAXD;AAaC;EACC,WA1BO;EA2BP,gBAAA;EACA,cAAA;EACA,mBCrCgB;EDsChB,qBAAA;EACA,kBAAA;EACA,YA5BO;EA6BP,iBA7BO;EA8BP,qBAAA;EACA,kBAAA;EACA,kBAAA;AAXF;AAYE;EACC,mBC9Ce;ADoClB;AAcE;EACC,kBAAA;EACA,0BAAA;AAZH;AAaG;EACC,YAAA;AAXJ;AAgBE;EAEC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,uBAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;AAfH;AAkBE;EACC,WAAA;EACA,8BAAA;AAhBH;AAkBE;EACC,UAAA;EACA,yBAAA;EACA,0BC7Ee;AD6DlB;AAkBE;EACC,yBCjFe;ADiElB;AAkBG;EACC,qBCpFc;EDqFd,8BAAA;AAhBJ;AAkBG;EACC,0BCxFc;ADwElB;AAmBE;EACC,yBC7Fc;AD4EjB;AAmBG;EACC,qBChGa;EDiGb,8BAAA;AAjBJ;AAmBG;EACC,0BCpGa;ADmFjB","sourcesContent":["@import \"../../../../../assets/css/colores.scss\";\r\n\r\n.contenedor {\r\n\tpadding: 8px;\r\n\t.header,\r\n\t.side,\r\n\t.main,\r\n\t.historial {\r\n\t\tmargin: 8px;\r\n\t}\r\n}\r\n\r\n$fondo-normal: $oa-secundario3;\r\n$fondo-activo: $oa-secundario2;\r\n$fondo-hover: $oa-secundario;\r\n$letras: #fff;\r\n$color-icono: #555555;\r\n$titulo-size: 1rem;\r\n$subtitulo-size: 0.75rem;\r\n$altura: 40px; // debe ser numero par\r\n\r\ndiv.status{\r\n\tpadding: 7px 12px;\r\n\tborder-radius: 10px;\r\n\tcolor: white;\r\n\tfont-weight: bold;\r\n\r\n\t&.ganado {\r\n\t\tbackground-color: rgb(54, 175, 54);\r\n\t}\r\n\t&.perdido {\r\n\t\tbackground-color: red;\r\n\t}\r\n}\r\n\r\ndiv.fase {\r\n\tfloat: left;\r\n\tcursor: pointer;\r\n\twidth: 20%;\r\n\r\n\tdiv.contenido {\r\n\t\tcolor: $letras;\r\n\t\tmax-width: 300px;\r\n\t\tdisplay: block;\r\n\t\tbackground: $fondo-normal;\r\n\t\ttext-decoration: none;\r\n\t\tposition: relative;\r\n\t\theight: $altura;\r\n\t\tline-height: $altura;\r\n\t\tpadding: 0 10px 0 5px;\r\n\t\ttext-align: center;\r\n\t\tmargin-right: 22px;\r\n\t\t&.fase-completa{\r\n\t\t\tbackground: $fondo-normal;\r\n\t\t}\r\n\t}\r\n\t&:first-child {\r\n\t\tdiv.contenido {\r\n\t\t\tpadding-left: 15px;\r\n\t\t\tborder-radius: 4px 0 0 4px;\r\n\t\t\t&:before {\r\n\t\t\t\tborder: none;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\tdiv.contenido {\r\n\t\t&:before,\r\n\t\t&:after {\r\n\t\t\tcontent: \"\";\r\n\t\t\tposition: absolute;\r\n\t\t\ttop: 0;\r\n\t\t\tborder: 0 solid $fondo-normal;\r\n\t\t\tborder-width: $altura/2 10px;\r\n\t\t\twidth: 0;\r\n\t\t\theight: 0;\r\n\r\n\t\t}\r\n\t\t&:before {\r\n\t\t\tleft: -20px;\r\n\t\t\tborder-left-color: transparent;\r\n\t\t}\r\n\t\t&:after {\r\n\t\t\tleft: 100%;\r\n\t\t\tborder-color: transparent;\r\n\t\t\tborder-left-color: $fondo-normal;\r\n\t\t}\r\n\t\t&.fase-completada {\r\n\t\t\tbackground-color: $fondo-activo;\r\n\r\n\t\t\t&:before {\r\n\t\t\t\tborder-color: $fondo-activo;\r\n\t\t\t\tborder-left-color: transparent;\r\n\t\t\t}\r\n\t\t\t&:after {\r\n\t\t\t\tborder-left-color: $fondo-activo;\r\n\t\t\t}\r\n\t\t}\r\n\t\t&:hover {\r\n\t\t\tbackground-color: $fondo-hover;\r\n\r\n\t\t\t&:before {\r\n\t\t\t\tborder-color: $fondo-hover;\r\n\t\t\t\tborder-left-color: transparent;\r\n\t\t\t}\r\n\t\t\t&:after {\r\n\t\t\t\tborder-left-color: $fondo-hover;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n\r\n","\r\n$oa-principal : #d20a31;\r\n$oa-principal2 : #6d0015;\r\n$oa-principal3 : #f06f88;\r\n\r\n$oa-secundario : #0a738c;\r\n$oa-secundario2 : #023b48;\r\n$oa-secundario3 : #539cad;\r\n\r\n$oa-accent : #46c309;\r\n$oa-accent2 : #216500;\r\n$oa-accent3 : #90e268;\r\n\r\n$oa-accent-secundario : #E1750B;\r\n$oa-accent-secundario2 : #753A00;\r\n$oa-accent-secundario3 : #FFBA76;\r\n\r\n$oa-background : #023b48;\r\n\r\n$oa-blanco-bg : white;\r\n$oa-blanco : white;\r\n\r\n$oa-gris : #6e6e6e;\r\n$oa-gris-claro : #a3a3a3;\r\n$oa-gris-oscuro : #424242;\r\n\r\n$oa-color-link: #3e92ff;\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
